export default __webpack_public_path__ + "static/media/chart_video.365ac013.mp4";